import { Form } from 'react-bootstrap';

function DonorListGender({label, selectedGenders, gender, id, onClick }) {
   
    const isChecked = selectedGenders.includes(gender);
  
    return (
      <Form.Group controlId={id}>
      <Form.Check 
        type="checkbox" 
        label={label}
        checked={isChecked} 
        onChange={() => onClick(gender)} 
      />
    </Form.Group>
    );
  }
  
  export default DonorListGender;
  